import {
  RailsBlock,
  RailsTile,
  RailsTileVersion,
} from '@sls-react/typings/services/rails/tile';
import useMobile from '@sls-react/hooks/useMobile';

export default function useTileVersion(
  block: RailsBlock,
  index = 0,
): RailsTile & Partial<RailsTileVersion> {
  const mobile = useMobile();

  const blockLayoutVersion = block.tiles?.[index]?.versions?.find(
    v => v.block_layout === block.layout,
  );

  if (blockLayoutVersion) {
    return {
      ...block.tiles?.[index]!,
      ...blockLayoutVersion,
    };
  }

  const platformVersion = block.tiles?.[index]?.versions?.find(
    v => v.platform === (mobile ? 'mobile' : 'web'),
  );

  return {
    ...block.tiles?.[index]!,
    ...platformVersion,
  };
}
